import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["monthlyLimit", "creditsForLimit"]
  }

  static get values() {
    return {
      creditsPerPack: Number,
      pricePerPack: Number,
    }
  }

  connect() {
    this.calculateCreditsForLimit()
  }

  calculateCreditsForLimit() {
    const monthlyLimit = Number(this.monthlyLimitTarget.value)
    const numberOfPacks = Math.floor(monthlyLimit / this.pricePerPackValue)
    const creditsForLimit = numberOfPacks * this.creditsPerPackValue
    this.creditsForLimitTarget.textContent = creditsForLimit
  }
}
